import { useState } from 'react';
import { StyledAuthLayout } from '../../components/Containers';
import { Helmet } from 'react-helmet';
import { useIntl } from '@/components/formatted_message/FormattedMessage';
import { EnmonLogo } from '../../components/EnmonLogo';
import { Page as messages } from '../two-factor/messages';
import { TwoFactorStep } from './enums/two-factor-step';
import { SetupContent } from './components/SetupContent';
import { VerifyContent } from './components/VerifyContent';
import { Case, ContentSwitch } from '@/components/content_switch';
import { useLocation } from 'react-router-dom';
import { PasswordContent } from './components/PasswordContent';
import { getInitialTwoFactorStep } from './utils/getInitialTwoFactorStep';

export const TwoFactorPage = () => {
  const intl = useIntl();
  const {
    state: { requireSetup, password },
  } = useLocation<{ requireSetup: boolean; password: string | undefined }>();

  const [step, setStep] = useState<TwoFactorStep>(getInitialTwoFactorStep(password, requireSetup));
  const [filledPassword, setFilledPassword] = useState<string | undefined>(password);
  const [backupCodes, setBackupCodes] = useState<string[]>([]);

  return (
    <StyledAuthLayout>
      <Helmet>
        <title>{intl.formatMessage(messages.title)}</title>
      </Helmet>
      <EnmonLogo />
      <ContentSwitch activeId={step}>
        <Case id={TwoFactorStep.Password}>
          <PasswordContent
            onContinue={password => {
              setFilledPassword(password);
              setStep(TwoFactorStep.Setup);
            }}
          />
        </Case>

        <Case id={TwoFactorStep.Setup}>
          <SetupContent onBackupCodesGenerated={setBackupCodes} onStepChange={setStep} password={filledPassword} />
        </Case>
        <Case id={TwoFactorStep.Verify}>
          <VerifyContent backupCodes={backupCodes} onStepChange={setStep} requireSetup={requireSetup} />
        </Case>
      </ContentSwitch>
    </StyledAuthLayout>
  );
};
